import {
    Avatar,
    Box,
    Breadcrumbs,
    Button,
    Chip,
    Container,
    Grid,
    IconButton,
    Pagination,
    Skeleton,
    Stack,
    Typography,
  } from "@mui/material";
  import { useEffect, useState } from "react";
  import {
    Link,
    useNavigate,
    useParams,
    useSearchParams,
  } from "react-router-dom";
  import {
    getApplciantsJobid,
    getApplicantInfo,
    getCandidatesWithStatus,
    getJobTitles,
    resumeDatabase,
  } from "../../firebase/functions";
  import { fireBaseTime } from "../../Helpers/TimeConvert";
  import {
    CandidateFacebookIcon,
    CandidateInstagramIcon,
    CandidateLinkedinIcon,
    CandidateTwitterIcon,
    FeturedJobsClockIcon,
    FeturedJobsLocationIcon,
  } from "../../utilities/Icons/Icons";
  import FindJobsBgImage from "../../utilities/images/find-jobs-bg.png";
  import "../../pages/CanditateProfile/CandidateProfile.css";
  import CandidateProfileAwards from "../../pages/CanditateProfile/CandidateProfileAwards";
  import CandidateProfileEducation from "../../pages/CanditateProfile/CandidateProfileEducation";
  import CandidateProfileWorksExperience from "../../pages/CanditateProfile/CandidateProfileWorksExperience";
  import styled from "@emotion/styled"; 
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  
  const SuperAdminDashboardCandidateProfile = () => {
    const [query, setQuery] = useSearchParams();
    const filter = query.get("filter");
    const { id ,jobId } = useParams();
    const [overViews, setOverViews] = useState([]);
    const [originalOverviews, setOriginalOverviews] = useState([]);
    const [filterOverviews, setFilterOverviews] = useState([]);
    const [jobTitles, setJobTitles] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [options, setOptions] = useState({});
    const applicantId = id;
    const [status, setStatus] = useState("");
    const [userInfo, setUserInfo] = useState({});
    const [date, setDate] = useState(new Date());
    const [age, setAge] = useState(0);
    const [change, setChange] = useState(true);
    const [loading, setLoading] = useState(false);
  
    const navigate = useNavigate();
    useEffect(() => {
      getJobTitles({ jobId }).then(({ data }) => {
        setJobTitles(data);
        setOptions({
          title: data,
          status: filter ? filter : "all",
        });
      });
      if (filter !== "resumeDatabase") {
        getApplciantsJobid({ jobId: jobId }).then(({ data }) => {
          setOverViews(data);
          setOriginalOverviews(data);
          setFilterOverviews(data);
        });
      } else {
        resumeDatabase({ jobId }).then(({ data }) => {
          const mappedData = data.map((data) => {
            return {
              appliedBy: data.id,
              status: "resumeDatabase",
            };
          });
          setOriginalOverviews(mappedData);
          setOverViews(mappedData);
          const index = mappedData.findIndex(
            (data) => data.appliedBy === applicantId
          );
          console.log("mapped data", mappedData, index);
          setCurrentPage(1 + index);
          // navigate(
          //   `/candidate-profile/${
          //     data[0].appliedBy ? data[0].appliedBy : data[0].id
          //   }/${jobId}`
          // );
        });
      }
    }, []);
    useEffect(() => {
      console.log("LOAADING CANDIDATE", loading);
      setLoading(true);
      getApplicantInfo({ applicantId }).then(({ data }) => {
        setUserInfo(data);
        setLoading(false);
        setDate(fireBaseTime(data.createdAt));
        let date = new Date().getFullYear();
        let birthDate = data?.dob?.split("-");
        //
        setAge(date - birthDate[0]);
      });
      if (filter != "resumeDatabase") {
        originalOverviews.filter((value, index) => {
          if (value.id === applicantId) {
            setCurrentPage(index + 1);
          }
        });
      } else {
        originalOverviews.filter((value, index) => {
          if (value.applicantId === applicantId) {
            setCurrentPage(index + 1);
          }
        });
      }
    }, [applicantId]);
  
    const handlePageChange = (action) => {
      if (action == "next") {
        if (currentPage < originalOverviews.length) {
          setCurrentPage(currentPage + 1);
          navigate(
            `/candidate-profile/${
              originalOverviews[currentPage].appliedBy
                ? originalOverviews[currentPage].appliedBy
                : originalOverviews[currentPage].id
            }/${jobId}`
          );
        }
      } else {
        if (currentPage > 1) {
          setCurrentPage(currentPage - 1 ? currentPage - 1 : 0);
          navigate(
            `/candidate-profile/${
              originalOverviews[currentPage - 2].appliedBy
                ? originalOverviews[currentPage - 2].appliedBy
                : originalOverviews[currentPage - 2].id
            }/${jobId}`
          );
        }
      }
    };
    useEffect(() => {
      console.log("CHANGE", change);
    }, [options]);
    const handleSelectionChange = (e) => {
      setLoading(true);
      if (e.target.value == "resumeDatabase") {
        resumeDatabase({ jobId }).then(({ data }) => {
          setLoading(false);
          const mappedData = data.map((data) => {
            return {
              appliedBy: data.id,
              status: "resumeDatabase",
            };
          });
          setOriginalOverviews(mappedData);
          setOverViews(mappedData);
          setCurrentPage(1);
          navigate(
            `/candidate-profile/${
              data[0].appliedBy ? data[0].appliedBy : data[0].id
            }/${jobId}`
          );
        });
        return;
      }
      getCandidatesWithStatus({ jobId, status: e.target.value }).then(
        ({ data }) => {
          setLoading(false);
          setOriginalOverviews(data);
          console.log("MILAAAA", data);
          setCurrentPage(1);
          navigate(
            `/candidate-profile/${
              data[0].appliedBy ? data[0].appliedBy : data[0].id
            }/${jobId}/?filter=${options.status}`
          );
        }
      );
    };
    return (
      <Box>
        {/* // {JSON.stringify({ filter, resumeDatabase })}sd */}
        {/* {JSON.stringify(options)} */}
        <Box sx={{ marginBottom: "20px" }}>
          {/* <NavBar color={"green"} /> */}
        </Box>
        <Box
          style={{
            backgroundImage: `url(${FindJobsBgImage})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "cover",
            height: "260px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box sx={{ textAlign: "center" }}>
            <Typography sx={{ color: "#fff", fontSize: "30px", fontWeight: 500 }}>
              CandidateProfile
            </Typography>
            <Typography
              sx={{
                color: "#fff",
                fontSize: "15px",
                fontWeight: 500,
                mt: "15px",
              }}
            >
              Home / Jobs
            </Typography>
          </Box>
        </Box>
        {/* filterss */}
        <Container
          sx={{
            maxWidth: "1200px",
            height: "100px",
            // border: "1px solid red",
            margin: "0 auto",
            // display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {/* <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
          >
            <Typography>{options.title}</Typography>
            <Typography>
              {options.status === "all"
                ? "All"
                : options.status === "accepted"
                ? "Shorlisted"
                : options.status === "rejected"
                ? "Rejected"
                : options.status === "pending"
                ? "Yet to be reviewed"
                : options.status === "hired"
                ? "Hired"
                : options.status === "resumeDatabase"
                ? "Resume Database"
                : null}
            </Typography>
            {originalOverviews.length ? (
              <Typography>
                {`${userInfo?.firstName} ${userInfo?.lastName}`}
              </Typography>
            ) : null}
          </Breadcrumbs> */}
  
          <Stack direction alignItems={"center"}>
            {/* <StyledFilter
              onChange={(e) => {
                setOptions({ ...options, title: e.target.value });
              }}
            >
              {jobTitles.map((job, index) => {
                return (
                  <option
                    selected={job.id == jobId ? true : false}
                    value={job.id}
                  >
                    {job.title}
                  </option>
                );
              })}
            </StyledFilter> */}
            {/* <StyledFilter
              onChange={async (e) => {
                setOptions({ ...options, status: e.target.value });
                handleSelectionChange(e);
                setChange(!change);
              }}
            >
              {[
                { value: "all", label: "All Applicants" },
                { value: "pending", label: "Yet to be Reviewed" },
                { value: "accepted", label: "Shortliisted" },
                { value: "rejected", label: "Rejected" },
                { value: "hired", label: "Hired" },
                { value: "resumeDatabase", label: "Resume Database" },
              ].map((item, index) => {
                return (
                  <option
                    selected={
                      options.status ? options.status == item.value : "all"
                    }
                    value={item.value}
                  >
                    {item.label}
                  </option>
                );
              })}
            </StyledFilter> */}
            {/* <Stack direction alignItems={"center"}>
              <IconButton onClick={() => handlePageChange("prev")}>
                <ArrowBackIosIcon />
              </IconButton>
              <Typography>
                {`${originalOverviews.length ? currentPage : 0}/${
                  originalOverviews.length
                }`}
              </Typography>
              <IconButton onClick={() => handlePageChange("next")}>
                <ArrowForwardIosIcon />
              </IconButton>
            </Stack> */}
          </Stack>
        </Container>
        {/* {loading.toString()} */}
        {/* {JSON.stringify(originalOverviews)} */}
        {originalOverviews.length == 0 ? (
          <Typography>Loading</Typography>
        ) : loading ? (
          <Container>
            <Skeleton variant="rect" width="80%" height="500px" />
          </Container>
        ) : (
          <Container sx={{ my: "70px" }}>
            <Box sx={{ display: "flex", gap: "30px" }}>
              <Box sx={{ width: "70%" }}>
                <Box>
                  <Box
                    sx={{ display: "flex", alignItems: "center", gap: "20px" }}
                  >
                    <Avatar
                      sx={{
                        overflow: "hidden",
                        width: "130px",
                        height: "130px",
                        borderRadius: "50%",
                      }}
                    >
                      <img
                        style={{ width: "100%", height: "100%" }}
                        src={userInfo?.displayImage}
                        alt=""
                      />
                    </Avatar>
                    <Box>
                      <Typography
                        sx={{
                          color: "#202124",
                          fontFamily: "Sofia Pro",
                          fontSize: "26px",
                          fontWeight: 500,
                        }}
                      >
                        {userInfo?.firstName} {userInfo?.lastName}
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "20px",
                          mt: "5px",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <Typography
                            sx={{
                              color: "#696969",
                              fontFamily: "Sofia Pro",
                              fontSize: "14px",
                            }}
                          >
                            {userInfo?.jobPreference}
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <FeturedJobsLocationIcon />
                          <Typography
                            sx={{
                              color: "#696969",
                              fontFamily: "Sofia Pro",
                              fontSize: "14px",
                            }}
                          >
                      {`${userInfo?.city}, ${userInfo?.state}`}
                          </Typography>
                        </Box>
                        {/* <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <FeturedJobsMoneyIcon />
                      <Typography
                        sx={{
                          color: "#696969",
                          fontFamily: "Sofia Pro",
                          fontSize: "14px",
                        }}
                      >
                        {userInfo?.payByHour ? userInfo.payByHour : "N/A"}
                      </Typography>
                    </Box> */}
  
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <FeturedJobsClockIcon />
                          <Typography sx={{ color: "#696969", fontSize: "14px" }}>
                            {userInfo.createdAt
                              ? `Member Since, ${
                                  months[date.getMonth()]
                                } ${date.getDate()} , ${date.getFullYear()} `
                              : null}
                          </Typography>
                        </Box>
                      </Box>
  
                      {/* <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "15px",
                          mt: "15px",
                        }}
                      >
                        <Typography
                          sx={{
                            color: "#1967D2",
                            background: "#DDE8F8",
                            height: "25",
                            padding: "5px 20px",
                            fontSize: "13px",
                            borderRadius: "60px",
                            fontFamily: "Sofia Pro",
                            textAlign: "center",
                          }}
                        >
                          App
                        </Typography>
                      </Box> */}
                    </Box>
                  </Box>
  
                  <Stack
                    spacing={3}
                    sx={{
                      width: "100%",
                      padding: "30px",
                      my: "30px",
                      border: "1px solid #ECEDF2",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#202124",
                          fontSize: "18px",
                          fontWeight: 500,
                        }}
                      >
                        Candidate Overview
                      </Typography>
                      {/* <Typography
                    sx={{ color: "#25C027", fontSize: "18px", fontWeight: 500 }}
                  >
                    View Details
                  </Typography> */}
                      {/* <MethodTags method={} status={} /> */}
                    </Box>
  
                    <Grid
                      container
                      rowSpacing={3}
                      columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                    >
                      <Grid item md={4}>
                        <Box sx={{ display: "flex", gap: "20px" }}>
                          <Box>
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M0 17C0 18.7 1.3 20 3 20H17C18.7 20 20 18.7 20 17V9H0V17ZM17 2H15V1C15 0.4 14.6 0 14 0C13.4 0 13 0.4 13 1V2H7V1C7 0.4 6.6 0 6 0C5.4 0 5 0.4 5 1V2H3C1.3 2 0 3.3 0 5V7H20V5C20 3.3 18.7 2 17 2Z"
                                fill="#25C027"
                              />
                            </svg>
                          </Box>
                          <Box>
                            <Typography
                              sx={{ color: "#202124", fontWeight: 500 }}
                            >
                              Experience:
                            </Typography>
                            <Typography
                              sx={{ color: "#696969", fontSize: "12px" }}
                            >
                              {userInfo?.experience
                                ? userInfo?.experience + " years"
                                : "N/A"}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
  
                      {/* <Grid item md={4}>
                    <Box sx={{ display: "flex", gap: "20px" }}>
                      <Box>
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0 17C0 18.7 1.3 20 3 20H17C18.7 20 20 18.7 20 17V9H0V17ZM17 2H15V1C15 0.4 14.6 0 14 0C13.4 0 13 0.4 13 1V2H7V1C7 0.4 6.6 0 6 0C5.4 0 5 0.4 5 1V2H3C1.3 2 0 3.3 0 5V7H20V5C20 3.3 18.7 2 17 2Z"
                            fill="#25C027"
                          />
                        </svg>
                      </Box>
                      <Box>
                        <Typography sx={{ color: "#202124", fontWeight: 500 }}>
                          Age:
                        </Typography>
                        <Typography sx={{ color: "#696969", fontSize: "12px" }}>
                          {age !== 0 ? age : "N/A"}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid> */}
                      <Grid item md={4}>
                        <Box sx={{ display: "flex", gap: "20px" }}>
                          <Box>
                            <svg
                              width="21"
                              height="21"
                              viewBox="0 0 21 21"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M9.55761 0.0420134C8.30628 0.160752 6.90673 0.559722 5.82352 1.10652C4.70288 1.67219 3.52984 2.56725 2.72602 3.46998C1.14933 5.24068 0.254666 7.28772 0.0385808 9.61913C-0.131095 11.4497 0.265048 13.5139 1.10559 15.1786C1.67132 16.2991 2.56648 17.472 3.46931 18.2757C5.24022 19.8523 7.28749 20.7468 9.61916 20.9629C11.0276 21.0934 12.6365 20.876 14.0132 20.3691C14.4068 20.2242 15.3705 19.7702 15.7586 19.5469L15.948 19.4379L18.4662 20.2185C19.8512 20.6479 20.9878 20.9957 20.9921 20.9915C20.9963 20.9872 20.6767 19.8047 20.2819 18.3635L19.564 15.7433L19.8294 15.225C21.2151 12.5195 21.3767 9.4754 20.2814 6.70945C20.0089 6.02126 19.8338 5.66743 19.4709 5.07086C18.5958 3.63266 17.3708 2.40773 15.9324 1.53277C15.3358 1.16987 14.9819 0.994838 14.2936 0.722362C12.8215 0.139581 11.1143 -0.105692 9.55761 0.0420134ZM11.6498 3.85619C14.5175 4.3725 16.7416 6.69419 17.1481 9.59562C17.2103 10.0396 17.2103 10.9629 17.1481 11.4069C16.7916 13.9514 15.0207 16.0933 12.6081 16.8976C11.8468 17.1514 11.2737 17.2432 10.4398 17.2451C9.52425 17.2471 8.90066 17.1391 8.08946 16.8379C6.18667 16.1314 4.69787 14.5965 4.04157 12.6645C3.7687 11.8613 3.7124 11.4911 3.7124 10.5013C3.7124 9.73721 3.72487 9.56144 3.80571 9.18832C4.13304 7.67778 4.87711 6.39303 5.98667 5.42281C7.0888 4.45899 8.39323 3.90415 9.9064 3.7555C10.2526 3.72149 11.2082 3.77667 11.6498 3.85619ZM10.2089 5.07861C9.71724 5.39376 9.23053 6.40993 8.94296 7.72152L8.87325 8.0395H10.5032H12.1332L12.0358 7.61895C11.6857 6.10857 11.0936 5.0647 10.5378 4.97842C10.4301 4.96168 10.3561 4.98421 10.2089 5.07861ZM8.04132 5.53818C7.08453 6.00083 6.17809 6.84682 5.66545 7.75562C5.59438 7.88153 5.53628 7.99695 5.53628 8.01205C5.53628 8.02715 6.00583 8.0395 6.57973 8.0395H7.62319L7.66919 7.80358C7.81494 7.05598 8.08482 6.17512 8.34169 5.60851C8.40054 5.47877 8.43406 5.37259 8.41621 5.37259C8.3984 5.37259 8.22971 5.4471 8.04132 5.53818ZM12.5941 5.43216C12.5941 5.44234 12.6569 5.59464 12.7336 5.77066C12.9564 6.28147 13.1884 7.06833 13.3332 7.80358L13.3796 8.0395H14.3798H15.38L15.2356 7.78405C14.7283 6.88661 13.8969 6.07321 13.0079 5.60453C12.6565 5.41928 12.5941 5.39331 12.5941 5.43216ZM4.99627 9.56784C4.96545 9.7345 4.94128 10.1449 4.94128 10.5013C4.94128 10.8576 4.96545 11.268 4.99627 11.4347L5.0513 11.7321H6.24781H7.44436V10.5013V9.27038H6.24781H5.0513L4.99627 9.56784ZM8.68154 9.64596C8.66685 9.8525 8.65486 10.2374 8.65486 10.5013C8.65486 10.7651 8.66685 11.15 8.68154 11.3566L8.70817 11.7321H10.5014H12.2946L12.3213 11.3566C12.3359 11.15 12.3479 10.7651 12.3479 10.5013C12.3479 10.2374 12.3359 9.8525 12.3213 9.64596L12.2946 9.27038H10.5014H8.70817L8.68154 9.64596ZM13.5584 10.5013V11.7321H14.6971C15.3234 11.7321 15.8358 11.7246 15.8358 11.7152C15.8358 11.7059 15.864 11.5536 15.8984 11.3767C15.9803 10.9553 15.9803 10.0472 15.8984 9.62578C15.864 9.4489 15.8358 9.2966 15.8358 9.28728C15.8358 9.27797 15.3234 9.27038 14.6971 9.27038H13.5584V10.5013ZM5.53628 12.9905C5.53628 13.0056 5.59438 13.121 5.66545 13.2469C6.03082 13.8946 6.73517 14.656 7.34354 15.0607C7.68133 15.2855 8.17009 15.5487 8.35819 15.6071L8.45133 15.636L8.34305 15.397C8.0847 14.8271 7.81523 13.948 7.66919 13.1989L7.62319 12.963H6.57973C6.00583 12.963 5.53628 12.9754 5.53628 12.9905ZM8.94296 13.281C9.03685 13.7093 9.17321 14.1851 9.29405 14.5061C9.65257 15.4585 10.1817 16.0939 10.5574 16.0234C11.1009 15.9215 11.6923 14.8656 12.0358 13.3836L12.1332 12.963H10.5032H8.87325L8.94296 13.281ZM13.3332 13.1989C13.1881 13.936 12.9563 14.7211 12.7322 15.2353C12.6546 15.4131 12.5999 15.5673 12.6105 15.5779C12.6212 15.5886 12.7964 15.5095 13 15.4022C13.8971 14.9292 14.7264 14.1191 15.2356 13.2185L15.38 12.963H14.3798H13.3796L13.3332 13.1989Z"
                                fill="#25C027"
                              />
                            </svg>
                          </Box>
                          <Box>
                            <Typography
                              sx={{ color: "#202124", fontWeight: 500 }}
                            >
                              Language:
                            </Typography>
                            <Box sx={{ display: "flex", flexWrap: "wrap" }}>
                              {userInfo?.languages?.map((item, index) => (
                                <Typography
                                  sx={{
                                    color: "#696969",
                                    fontSize: "12px",
                                    mr: "5px",
                                  }}
                                >
                                  {item},
                                </Typography>
                              ))}
                            </Box>
                          </Box>
                        </Box>
                      </Grid>
  
                      <Grid item md={4}>
                        <Box sx={{ display: "flex", gap: "20px" }}>
                          <Box>
                            <svg
                              width="22"
                              height="17"
                              viewBox="0 0 22 17"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M5.55113 2.54289C1.54686 4.47625 0.25553 5.11887 0.164232 5.22366C0.0982004 5.29943 0.0307472 5.43066 0.0142852 5.51516C-0.0286353 5.73638 0.0262534 5.95574 0.164232 6.11411C0.25553 6.2189 1.54686 6.86152 5.55113 8.79488C9.85579 10.8732 10.8511 11.3378 10.9998 11.3378C11.1479 11.3378 11.9804 10.9521 15.4929 9.2564L19.8041 7.17504V9.36712C19.8041 10.5728 19.7876 11.5592 19.7673 11.5592C19.6779 11.5592 19.3219 11.9574 19.213 12.1792C19.1144 12.38 19.0937 12.4851 19.0949 12.7771C19.0962 13.0938 19.1129 13.1611 19.2515 13.4105C19.4243 13.7211 19.568 13.8554 19.9139 14.0289C20.1136 14.1292 20.2054 14.1465 20.5378 14.1465C20.8702 14.1465 20.9621 14.1292 21.1618 14.0289C21.5076 13.8554 21.6514 13.7211 21.8241 13.4105C21.9628 13.1611 21.9794 13.0938 21.9808 12.7771C21.982 12.4859 21.9611 12.3794 21.8633 12.1792C21.7523 11.952 21.4031 11.5592 21.312 11.5592C21.2891 11.5592 21.2715 10.4548 21.2715 9.01339V6.46758L21.4948 6.35827C21.6176 6.29817 21.7716 6.18763 21.8369 6.11265C22.0549 5.86247 22.0543 5.47464 21.8356 5.22366C21.7443 5.11887 20.453 4.47625 16.4487 2.54289C12.1418 0.463431 11.1488 0 10.9999 0C10.8511 0 9.85808 0.463431 5.55113 2.54289ZM4.39677 12.0699C4.39677 13.861 4.40928 14.3368 4.45936 14.4526C4.54011 14.6393 4.94134 14.9841 5.52531 15.3687C8.40502 17.2654 12.1024 17.5266 15.2445 16.0554C16.2531 15.5831 17.3968 14.7848 17.5405 14.4526C17.5906 14.3368 17.6031 13.861 17.6031 12.0699C17.6031 10.839 17.5927 9.83197 17.58 9.83197C17.5673 9.83197 16.256 10.4602 14.6661 11.2282C13.0761 11.996 11.6583 12.6537 11.5155 12.6897C11.3726 12.7256 11.1407 12.755 10.9999 12.755C10.8592 12.755 10.6272 12.7256 10.4844 12.6897C10.3415 12.6537 8.92378 11.996 7.3338 11.2282C5.74381 10.4602 4.43253 9.83197 4.41983 9.83197C4.40713 9.83197 4.39677 10.839 4.39677 12.0699Z"
                                fill="#25C027"
                              />
                            </svg>
                          </Box>
                          <Box>
                            <Typography
                              sx={{ color: "#202124", fontWeight: 500 }}
                            >
                              Education Level:
                            </Typography>
                            <Typography
                              sx={{ color: "#696969", fontSize: "12px" }}
                            >
                              {userInfo?.educationLevel
                                ? userInfo.educationLevel
                                : "N/A"}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                      {/* //!MUST CHECK */}
                      <Grid item md={8}>
                        <Box
                          sx={{
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                          }}
                        >
                          {/* <StatusDrop
                            overView={{
                              ...overViews[currentPage - 1],
                              appliedBy: applicantId,
                            }}
                            setStatus={setStatus}
                            offerStatus={overViews[currentPage - 1]?.offerStatus}
                            jobId={jobId}
                            info={userInfo}
                          /> */}
                          {/* </Box> */}
  
                          <Box
                            component="a"
                            style={{ textDecoration: "none", color: "#fff" }}
                            target="_blank"
                            href={userInfo.resume}
                            download
                          >
                            <Button
                              disabled={userInfo.resume ? true : false}
                              sx={{
                                textTransform: "none",
                                fontSize: "15px",
                                fontFamily: "",
                                backgroundColor: "#24BD2C",
                                minHeight: "45px",
                                color: "#fff",
                                // padding: "1px 2px",
                                borderRadius: "8px",
                                "&:hover": {
                                  backgroundColor: "#24BD2C",
                                },
                              }}
                            >
                              {userInfo.resume
                                ? "Download Resume"
                                : "Resume Unavailable"}
                            </Button>
                          </Box>
  
                          {/* <Box
                            sx={{
                              width: "50px",
                              height: "50px",
                              borderRadius: "6px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              background: "#25C027",
                            }}
                          >
                            <CandidatedProfileMessageIcon />
                          </Box> */}
                        </Box>
                      </Grid>
                    </Grid>
                    {/* <Stack direction alignItems={"center"} gap={2}>
                      <StatusLogo
                        status={
                          overViews[currentPage - 1]?.status
                            ? overViews[currentPage - 1]?.status
                            : "resumeDatabase"
                        }
                        offerStatus={overViews[currentPage - 1]?.offerStatus}
                      />
                      <MethodTags
                        status={
                          overViews[currentPage - 1]?.status
                            ? overViews[currentPage - 1]?.status
                            : "resumeDatabase"
                        }
                        method={overViews[currentPage - 1]?.method}
                      />
                      <OfferStatus
                        status={
                          overViews[currentPage - 1]?.status
                            ? overViews[currentPage - 1]?.status
                            : "resumeDatabase"
                        }
                        offerStatus={overViews[currentPage - 1]?.offerStatus}
                      />
                    </Stack> */}
                  </Stack>
                </Box>
  
                <Stack spacing={3}>
                  <CandidateProfileEducation applicantId={applicantId} />
                  <CandidateProfileWorksExperience applicantId={applicantId} />
                  <CandidateProfileAwards applicantId={applicantId} />
                </Stack>
              </Box>
              <Box sx={{ width: "30%" }}>
                {userInfo?.facebook !== "" ||
                userInfo?.twitter !== "" ||
                userInfo?.linkedin !== "" ? (
                  <>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        backgroundColor: "#F0FBF0",
                        padding: "30px",
                        borderRadius: "8px",
                      }}
                    >
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "18px",
                            fontFamily: "Sofia Pro",
                            fontWeight: 500,
                            color: "#202124",
                          }}
                        >
                          Social media
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "15px",
                        }}
                      >
                        {userInfo?.facebook ? (
                          <a href={userInfo?.facebook} target="_blank">
                            <CandidateFacebookIcon />
                          </a>
                        ) : null}
                        {userInfo?.twitter ? (
                          <a href={userInfo?.twitter} target="_blank">
                            <CandidateTwitterIcon />
                          </a>
                        ) : null}
                        {userInfo?.linkedin ? (
                          <a href={userInfo?.linkedin} target="_blank">
                            {" "}
                            <CandidateLinkedinIcon />
                          </a>
                        ) : null}
                        {userInfo?.instagram ? (
                          <a href={userInfo?.instagram} target="_blank">
                            {" "}
                            <CandidateInstagramIcon />
                          </a>
                        ) : null}
                      </Box>
                    </Box>
                  </>
                ) : null}
  
                {userInfo?.skills?.length > 0 && (
                  <Box
                    sx={{
                      padding: "30px",
                      backgroundColor: "#F0FBF0",
                      mt: "30px",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "#202124",
                        fontFamily: "Sofia Pro",
                        fontSize: "18px",
                        fontWeight: 500,
                      }}
                    >
                      Professional Skills
                    </Typography>
                    {/* {//! SKILL BOX} */}
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "10px",
                        mt: "10px",
                      }}
                    >
                      {userInfo?.skills?.map((item, index) => {
                        return (
                          <Chip
                            sx={{
                              backgroundColor: "#fff",
                            }}
                            label={
                              <Typography
                                sx={{
                                  color: "#696969",
                                  fontFamily: "Sofia Pro",
                                  fontSize: "14px",
                                  backgroundColor: "#fff",
                                  padding: "7px 15px",
                                  borderRadius: "8px",
                                  display: "inline-block",
                                }}
                              >
                                {item}
                              </Typography>
                            }
                            key={index}
                          />
                        );
                      })}
                    </Box>
                  </Box>
                )}
  
                {/* <Box
                  sx={{
                    width: "100%",
                    backgroundColor: "#F0FBF0",
                    padding: "30px",
                    borderRadius: "8px",
                    mt: "30px",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "18px",
                      fontFamily: "Sofia Pro",
                      fontWeight: 500,
                      color: "#202124",
                    }}
                  >
                    Contact Us
                  </Typography>
  
                  <form style={{ marginTop: "20px" }} action="">
                    <input
                      className={classes.input}
                      placeholder="Your Name"
                      type="text"
                    />
                    <input
                      className={classes.input}
                      type="text"
                      placeholder="Email Address"
                    />
                    <textarea
                      className={classes.input}
                      style={{ height: "160px", maxWidth: "100%" }}
                      type="text"
                      placeholder="Message"
                    />
                    <Button
                      sx={{
                        width: "100%",
                        textTransform: "none",
                        fontSize: "15px",
                        fontFamily: "Sofia Pro",
                        backgroundColor: "#24BD2C",
                        color: "#fff",
                        padding: "14px 24px",
                        borderRadius: "8px",
                        "&:hover": {
                          backgroundColor: "#24BD2C",
                        },
                      }}
                    >
                      Send Message
                    </Button>
                  </form>
                </Box> */}
              </Box>
            </Box>
          </Container>
        )}
        {/* <CandidateView
          userInfo={userInfo}
          overViews={overViews}
          setStatus={setStatus}
          date={date}
          setDate={setDate}
  
        /> */}
        {/* <InstantMessageFeture />
        <Footer /> */}
      </Box>
    );
  };
  
  export default SuperAdminDashboardCandidateProfile;
  